import { Checkbox, Select, Tag } from 'antd';
import { useEffect, useState } from 'react';
import getFormatMessage from '../../../../../locales/get-format-message';
import { IAPIStudioMemberHasPermissionItem } from '../../../../../model/api-modules';
import { RoleGroupType } from '../../../../../model/rbac';
import { IOption } from '../../organization-content';
import { CustomPopover } from '../../../../../components/custom-popover';

interface IProps {
  readonly row?: IAPIStudioMemberHasPermissionItem;
  //   readonly rolesList: ReadonlyArray<IRBACRole>;
  readonly setRoleGroupList: (
    selectedOptions: string[],
    authType: RoleGroupType.Role | RoleGroupType.Group
  ) => void;
  readonly roleGroupNames?: string[];
  readonly roleName?: string | undefined;
  readonly rolesAndGroupsOptions: IOption[];
  readonly className?: string;
  readonly adminOptions?: IOption;
  readonly groupsOptions?: IOption[];
  readonly isJustRole?: boolean;
}
const { Option } = Select;

interface IOptionItem {
  label: string;
  value: string;
  group: string;
  disabled?: boolean;
  styles?: React.CSSProperties;
}

export const SelectRoleGroupComponent = (props: IProps) => {
  const [selectedOption, setSelectedOption] = useState<string[]>([]);
  const [options, setOptions] = useState<IOptionItem[]>([]);
  let groupsOptions: IOption[] | [];
  useEffect(() => {
    groupsOptions = props.rolesAndGroupsOptions.filter(
      (item) => item.label !== 'Admin' && item.label !== 'admin'
    );
    if (groupsOptions.length > 1) {
      groupsOptions.sort((pre, next) => {
        let sortPre = 0;
        let sortNext = 0;
        if (pre.label === 'Admin Group') {
          sortPre = 3;
        } else if (pre.label === 'Editor Group') {
          sortPre = 2;
        } else if (pre.label === 'Viewer Group') {
          sortPre = 1;
        }
        if (next.label === 'Admin Group') {
          sortNext = 3;
        } else if (next.label === 'Editor Group') {
          sortNext = 2;
        } else if (next.label === 'Viewer Group') {
          sortNext = 1;
        }
        return sortNext - sortPre;
      });
    }
    const initOptions =
      groupsOptions.length === 0
        ? [
            {
              label: getFormatMessage('no_create_group'),
              value: '',
              disabled: true,
              styles: { color: '#86909C' },
              group: RoleGroupType.Group,
            },
          ]
        : groupsOptions.map((option) => ({
            label: option.label,
            value: option.value,
            group: RoleGroupType.Group,
          }));
    console.log('initOptions-----------', initOptions);
    // if(adminOptions){
    setOptions(initOptions);
    // }
  }, [props.rolesAndGroupsOptions]);

  useEffect(() => {
    if (props.roleGroupNames && props.roleGroupNames.length > 0) {
      const selectedValues = props.roleGroupNames.map((label) => {
        if (groupsOptions) {
          const selectedValue = groupsOptions.find(
            (option) => option.label === label
          );
          console.log('有初始值的选中-----------', selectedValue);
          if (selectedValue) {
            return selectedValue.value;
          }
        }
        return '';
      });
      setSelectedOption(selectedValues);
      props.setRoleGroupList(selectedValues, RoleGroupType.Group);
    } else {
      const currentGroupsOptions = props.rolesAndGroupsOptions.filter(
        (item) => item.label !== 'Admin' && item.label !== 'admin'
      );
      const viewerGroupItem = currentGroupsOptions?.find(
        (item) => item.label === 'Viewer Group'
      );
      setSelectedOption(viewerGroupItem?.value ? [viewerGroupItem?.value] : []);
      props.setRoleGroupList(
        viewerGroupItem?.value ? [viewerGroupItem?.value] : [],
        RoleGroupType.Group
      );
    }
  }, [props.roleGroupNames, props.roleName]);

  const handleRoleGroupChange = (selectedOptions: string[]) => {
    console.log('selectedOptions--', selectedOptions);
    const currentGroupsOptions = props.rolesAndGroupsOptions.filter(
      (item) => item.label !== 'Admin' && item.label !== 'admin'
    );
    const adminGroupItem = currentGroupsOptions?.find(
      (item) => item.label === 'Admin Group'
    );
    if (adminGroupItem && selectedOptions.includes(adminGroupItem.value)) {
      setSelectedOption([adminGroupItem.value]);
      props.setRoleGroupList([adminGroupItem.value], RoleGroupType.Group);
      return;
    }
    if (selectedOptions.length === 0) {
      setSelectedOption([]);
      props.setRoleGroupList([], RoleGroupType.Group);
    } else {
      setSelectedOption(selectedOptions);
      props.setRoleGroupList(selectedOptions, RoleGroupType.Group);
    }
  };

  const tagRender = (itemProps: any) => {
    const { value, onClose, label } = itemProps;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };
    const valueGroup = value.split('-')[0];
    if (valueGroup === RoleGroupType.Role) {
      return <div>{getFormatMessage('Admin')}</div>;
    }
    return (
      <Tag onMouseDown={onPreventMouseDown} onClose={onClose} closable={true}>
        {label}
      </Tag>
    );
  };

  const getIsDisabled = (value: string) => {
    const currentGroupsOptions = props.rolesAndGroupsOptions.filter(
      (item) => item.label !== 'Admin' && item.label !== 'admin'
    );
    const adminGroupItem = currentGroupsOptions?.find(
      (item) => item.label === 'Admin Group'
    );
    if (adminGroupItem) {
      if (
        adminGroupItem.value !== value &&
        selectedOption.includes(adminGroupItem.value)
      ) {
        return true;
      }
    }
    return false;
  };

  return (
    <>
      <div className="edit-title edit-select-title">
        {getFormatMessage('group')}
        <span className="require-icon">*</span>
      </div>
      <Select
        className={`${props.className} edit-select-role`}
        value={selectedOption}
        onChange={handleRoleGroupChange}
        mode="multiple"
        getPopupContainer={(triggerNode) => triggerNode.parentNode} // 指定下拉菜单的容器
        dropdownClassName="edit-select-role-dropdown"
        maxTagCount={5}
        placeholder={getFormatMessage('select_the_group')}
        showSearch={false} // 不支持输入
        tagRender={tagRender}
      >
        {options.map((option) => {
          return (
            <Option
              key={option.value}
              value={option.value}
              disabled={option.disabled || getIsDisabled(option.value)}
              style={option.styles}
            >
              {getIsDisabled(option.value) ? (
                <CustomPopover
                  content={getFormatMessage('highest_selected')}
                  placement="topLeft"
                >
                  <div className="group-role">
                    <Checkbox
                      value={option.value}
                      checked={selectedOption.includes(option.value)}
                    />
                    <span>{option.label}</span>
                  </div>
                </CustomPopover>
              ) : (
                <div className="group-role">
                  <Checkbox
                    value={option.value}
                    checked={selectedOption.includes(option.value)}
                  />
                  <span>{option.label}</span>
                </div>
              )}
            </Option>
          );
        })}
      </Select>
    </>
  );
};
